<script>
    import { show_remove, UserData, pals } from "./stores";

    let add = false;
    let name = "";

    function showAdd() {
        add = !add;
    }

    function focus(input) {
        input.focus()
    }

    function addThem() {
        if (name !== "" && typeof name === "string") {
            let newUser = new UserData(name);
            // Dont know why but the below wont work in the actual stores.js file
            $pals = [...$pals, newUser];

            name = "";
            showAdd();
        }
    }
</script>

<div id="addnew">
    <button on:click={showAdd}>
        {#if !add}
            Add new
        {:else}
            Cancel
        {/if}
    </button>
    <button on:click={() => {$show_remove = !$show_remove;}}>
        {#if !$show_remove}
            Remove Pal
        {:else}
            Cancel Remove
        {/if}
    </button>
</div>

{#if add}
    <div class="row">
        <input bind:value={name} use:focus />
        <button on:click={addThem}>Add</button>
    </div>
{/if}

<style>
    button {
        font-size: 18px;
        margin-right: 10px;
        border-radius: 0 0 10px 10px;
    }
    div.row {
        display: grid;
        grid-auto-flow: row;
        align-items: center;
    }
    div#addnew {
        margin-top: 20px;
        display: grid;
        justify-content: center;
        align-items: center;
        grid-template-columns: auto auto;
        font-size: 20px;
    }
</style>
